class AlertpopupController {
  constructor() {
    this.name = 'alertpopup';
  }
  dismissModal() {
    this.dismiss({
      $value: 'cancel'
    });
  }
  yes(){
    this.close({
      $value: 'yes'
    });
  }
}

export default AlertpopupController;



// WEBPACK FOOTER //
// ./client/app/components/home/settings/alertpopup/alertpopup.controller.js